<ng-container *ngIf="help$ | async as help">
	<div cdkTrapFocus tabindex="-1" aria-modal="true">
		<app-edit-header
			class="modal-header"
			cancelTooltip="Close"
			[cancelAccessKey]="'w'"
			[cancelFn]="close"
			[title]="help?.helpPageTitle"
			[buttonTemplateRef]="helpButtons"
			[headerClass]="'w-100 text-primary bg-transparent'"
			rowClass="row"
		></app-edit-header>
		<div class="modal-body">
			<div class="container mt-5">
				<div class="row justify-content-center clearfix" *ngFor="let t of help?.helpPageHelptext">
					<div class="col-12">
						<h3>{{ t.headerText }}</h3>
						<p [innerHTML]="t.helpText"></p>
					</div>
				</div>
			</div>
		</div>
		<ng-template #helpButtons>
			<div *ngIf="help?.printURL || help?.videoURL" ngbDropdown placement="bottom-end">
				<button
					ngbDropdownToggle
					class="btn btn-light dropdown-toggle"
					type="button"
					id="dropdownMenuButton"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					<i style="font-size: 2rem; line-height: 0.5rem" nstarIcon>…</i>
				</button>
				<div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton">
					<a
						*ngIf="help.printURL"
						[href]="help.printURL"
						target="_blank"
						ngbDropdownItem
						class="dropdown-item"
						href="#"
						>Print</a
					>
				</div>
			</div>
		</ng-template>
	</div>
</ng-container>
